/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

import { addElementTags, reloadBeam } from 'modules/tagularHelpers.js';
import { initAuthNavigation } from 'modules/authentication';

(($) => {
	// This condition is only true on mobile breakpoints, prevents function from running on desktop.
	if ($('#nav-icon').css('display') === 'block') {
		// Toggles slide animation for mobile nav.
		$('.menu-item').on('click', (e) => {
			const $menuItem = $(e.target).closest('.menu-item');
			const $innerNavList = $menuItem.children('.menu');
			const $menuTitle = $menuItem
				.children('.menu-item__content')
				.children('.menu-item__title');
			if ($menuItem.hasClass('menu-item-has-children')) {
				e.preventDefault();
				if ($innerNavList.css('display') === 'none') {
					$innerNavList
						.slideDown('fast')
						.attr('aria-expanded', 'true');
					$menuTitle.addClass('open');
				} else {
					$innerNavList
						.slideUp('fast')
						.attr('aria-expanded', 'false');
					$menuTitle.removeClass('open');
				}
			}
		});

		// Post content has relative positioning that prevents nav container from covering the content.
		$('#nav-icon').on('click', () => {
			closeUserMenu();
			closeSearch();
		});
	}

	// Handle search component.
	const header = $('.header');
	const searchBtn = $('#search-btn');
	const searchComponent = $('.search-component');
	const searchOverlay = header.find('.search-form__overlay');
	const searchForm = $('.search-form');
	const searchClearBtn = searchForm.find('.search-form__close-btn');
	const searchInput = searchForm.find('.search-form__input');
	const suggestionsList = searchForm.find('.search-form__suggestions');
	const postBody = $('body');
	const isDesktop = screen.width >= 1024;

	const openSearch = () => {
		searchBtn.attr('data-tag-action-outcome', 'OPEN');
		searchBtn.addClass('open').removeClass('closed');
		searchOverlay.show();
		searchComponent.fadeIn();
		searchInput.trigger('focus');
		postBody.addClass('noscroll');
		closeUserMenu();
	};

	const closeSearch = () => {
		searchBtn.attr('data-tag-action-outcome', 'CLOSE');
		searchBtn.addClass('closed').removeClass('open');
		$(searchOverlay).off('click');
		searchOverlay.hide();
		searchComponent.fadeOut();
		postBody.removeClass('noscroll');
	};

	searchBtn.on('click', () => {
		if (searchBtn.hasClass('closed')) {
			openSearch();
			if (isDesktop) {
				// Close search suggestions when user clicks outside of it.
				searchOverlay.on('click', function () {
					closeSearch();
				});
			}
		} else if (searchBtn.hasClass('open')) {
			closeSearch();
		}
	});

	searchClearBtn.on('click', () => {
		if (searchInput.val() === '') {
			closeSearch();
		}
		searchInput.val('');
		clearSuggestions();
	});

	// Request search suggestions as user is typing.
	searchInput.on('input', (e) => {
		const inputValue = $(e.target).val();

		if (inputValue.length >= 3) {
			getSearchSuggestions(inputValue);
		} else {
			clearSuggestions();
		}
	});

	// Handle AJAX call to search handler php.
	const getSearchSuggestions = (search) => {
		const requestData = {
			s: search,
			nonce: search_ajax.nonce, //eslint-disable-line no-undef
		};

		$.ajax({
			type: 'GET',
			url: `${templateDirectory}/includes/get-search-suggestions.php`, //eslint-disable-line no-undef
			data: requestData,
		})
			.done((response) => {
				const searchSuggestions = JSON.parse(response);
				updateSuggestionsList(searchSuggestions, search);
			})
			.fail(() => {
				clearSuggestions();
			});
	};

	// Render the html for the suggestions list.
	// Handle setting of tagular events.
	const updateSuggestionsList = (suggestions, searchTerm) => {
		let items = '';
		const elementProps = {
			elementType: 'AUTOSUGGEST',
			location: 'search-bar',
			name: 'view-results',
			position: 0,
		};

		const elementTagsViewResults = addElementTags(true, elementProps);
		const resultsText =
			suggestions.total_results === 1
				? 'Resultado Encontrado'
				: 'Resultados Encontrados';
		items += `<li class="search-form__suggestions-item"><a ${elementTagsViewResults} href="/search/${searchTerm}">${suggestions.total_results} ${resultsText}</a></li>`;
		suggestions.posts.forEach((suggestion, index) => {
			elementProps.name = 'suggestion-box';
			elementProps.position = index;
			const elementTags = addElementTags(true, elementProps);
			items += `<li class="search-form__suggestions-item"><a ${elementTags} href="${suggestion.url}">${suggestion.title}</a></li>`;
		});
		suggestionsList.html(items);
		suggestionsList.show();
		reloadBeam();
	};

	const clearSuggestions = () => {
		suggestionsList.html('');
		suggestionsList.hide();
	};

	const userBtn = $('#user-btn');
	const userMenu = $('.user-menu');
	const userMenuOverlay = header.find('.user-menu__overlay');

	const openUserMenu = () => {
		userBtn.attr('data-tag-action-outcome', 'OPEN');
		userBtn.addClass('open').removeClass('closed');
		userMenuOverlay.show();
		userMenu.fadeIn();
		postBody.addClass('noscroll');
		closeSearch();
	};

	const closeUserMenu = () => {
		userBtn.attr('data-tag-action-outcome', 'CLOSE');
		userBtn.addClass('closed').removeClass('open');
		$(userMenuOverlay).off('click');
		userMenuOverlay.hide();
		userMenu.fadeOut();
	};

	userBtn.on('click', () => {
		if (userBtn.hasClass('closed')) {
			openUserMenu();
			// Close search suggestions when user clicks outside of it.
			userMenuOverlay.on('click', function () {
				closeUserMenu();
			});
		} else if (userBtn.hasClass('open')) {
			closeUserMenu();
		}
	});

	initAuthNavigation();
})(jQuery);
